import {
  IGetVendorPincodeListRow,
  IVendorPincodeListSearch,
} from "../../../types/master/vendorPincodeInterface";
import { VendorPincodeActionTypes, VendorPincodeActions } from "../../actionTypes/master/vendorPincodeActionTypes";

export const getVendorPincodeList = (payload: IVendorPincodeListSearch): VendorPincodeActionTypes => ({
  type: VendorPincodeActions.GET_VENDOR_PINCODE_LIST,
  payload,
});

export const setVendorPincodeList = (rows: Array<IGetVendorPincodeListRow>): VendorPincodeActionTypes => ({
  type: VendorPincodeActions.SET_VENDOR_PINCODE_LIST,
  payload: rows,
});

export const setVendorPincodeListPageCount = (payload: number): VendorPincodeActionTypes => ({
  type: VendorPincodeActions.SET_VENDOR_PINCODE_LIST_PAGE_COUNT,
  payload,
});
